import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { MarkdownEditor, MarkdownPreview } from "components/common/MarkdownEditor";
import { ControlLabel } from "components/bootstrap";
import { Col } from "security-app/components/common/FormBaseStyles";
import { ErrorMessage } from "./ErrorMessage";
function FormikMarkdownEditor({ field, height = 150, label = null, disabled = false }) {
  const [{ name, value }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name });
  const onChange = useCallback(
    (newValue) => {
      setValue(newValue);
      setTouched(true);
    },
    [setValue, setTouched]
  );
  return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), disabled ? /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, withFullView: true, height, value }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MarkdownEditor, { id: name, height, value, onChange }), touched && error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error)));
}
export default FormikMarkdownEditor;
